import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { ContentControlApplicationRule } from '@nirvana/shared/dtos/types/policies/common';
import { getLabelByApplicationRuleItemPermission } from '../../../../../../utils/uiSettings/contentControl/content-control.values';

// sort by column type
export function sortByColumn(
  item1: ContentControlApplicationRule,
  item2: ContentControlApplicationRule,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.PERMISSION:
      return compareStrings(
        getLabelByApplicationRuleItemPermission(item1.permission),
        getLabelByApplicationRuleItemPermission(item2.permission),
        direction
      );

    case ColumnKeys.APP_PATH:
      return compareStrings(item1.appPath, item2.appPath, direction);
  }

  return 0;
}
